<template>
  <div class="add-email-container">
    <el-form
      ref="addEmailForm"
      :model="addEmailForm"
      label-position="left"
      class="add-email-form"
    >
      <p>您還未註冊此帳號的郵箱，現在請於下方填寫，<br>日後登錄時的一次性認證密碼(OTP)將會發送至這郵箱</p>
      <el-form-item>
        <el-input
          ref="email"
          v-model="addEmailForm.email"
          :placeholder="'郵箱'"
          type="text"
          @keyup.enter.native="handleOTPSendAgain"
        />
      </el-form-item>
      <el-form-item class="otp-box">
        <el-input
          ref="otp"
          v-model="addEmailForm.otp"
          :placeholder="'OTP'"
          type="text"
          class="otp-input"
          @keyup.enter.native="handleOTPSubmit"
        />
        <el-button
          class="otp-send-again-button"
          :loading="otpSendLoading"
          @click.native.prevent="handleOTPSendAgain"
          :disabled="coolDownToSendOtpAgain !== 0"
        >{{ coolDownToSendOtpAgain === 0 ? '發送OTP至郵箱' : `${coolDownToSendOtpAgain}秒後可重新發送` }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          class="otp-submit-button"
          :loading="otpSubmitLoading"
          type="primary"
          @click.native.prevent="handleOTPSubmit"
          :disabled="coolDownToSubmitOtpAgain !== 0"
        >{{ coolDownToSubmitOtpAgain === 0 ? '驗證OTP以確認郵箱' : `OTP不正確，${coolDownToSubmitOtpAgain}秒後可再試` }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {userAddEmail, sendOtp, verifyOtp} from "@/api/user";

  export default {
    data() {
      return {
        addEmailForm: {
          email: '',
          otp: '',
        },
        otpSendLoading: false,
        otpSubmitLoading: false,
        coolDownToSendOtpAgain: 0,
        coolDownToSubmitOtpAgain: 0,
        sendOtpAgainIntervalId: null,
        submitOtpAgainIntervalId: null,
        username: this.$route.query.username,
      }
    },
    methods: {
      async handleOTPSendAgain() {
        const { email } = this.addEmailForm;
        if (!email) return;
        try {
          this.otpSendLoading = true;
          const res = await sendOtp({ email });
          if (res.result == null) { // user not found
            console.warn("username not found")
            this.$router.push({ path: '/login' });
            this.$message.error("系統錯誤");
          } else if (typeof res.result === 'string' && res.result === email)  { // send success
            this.coolDownToSendOtpAgain = 30;
            // cooldown
            this.sendOtpAgainIntervalId = setInterval(_ => {
              this.coolDownToSendOtpAgain--
              if (this.coolDownToSendOtpAgain === 0) {
                clearInterval(this.sendOtpAgainIntervalId);
                this.sendOtpAgainIntervalId = null;
              }
            }, 1000);
            this.$message.success('發送成功');
            this.$refs.otp.focus();
          } else {
            console.error("something went wrong");
            this.$message.error("系統錯誤");
          }
        } catch (e) {
          console.error(e);
          this.$message.error("系統錯誤");
        } finally {
          this.otpSendLoading = false;
        }
      },
      async handleOTPSubmit() {
        const { otp, email } = this.addEmailForm;
        if (!otp || !email) return;
        try {
          this.otpSubmitLoading = true;
          // const res = await this.$store.dispatch('user/verifyOtp', { username: this.username, otp });
          const res = await verifyOtp({ otp, invalidateAfterVerify: true });
          if (res.result) { // verify success
            try {
              // request change email
              await userAddEmail({ email, otp });
            } catch(e) {
              console.error("something went wrong", e);
              return;
            }
            this.$router.push({ path: '/' });
          } else { // verify fail
            this.coolDownToSubmitOtpAgain = 5;
            // start interval count down
            this.submitOtpAgainIntervalId = setInterval(_ => {
              this.coolDownToSubmitOtpAgain--;
              if (this.coolDownToSubmitOtpAgain === 0) {
                clearInterval(this.submitOtpAgainIntervalId);
                this.submitOtpAgainIntervalId = null;
              }
            }, 1000);
          }
        } catch (e) {
        } finally {
          this.otpSubmitLoading = false;
        }
      },
    }
  }
</script>

<style lang="scss">
  .add-email-container {
    margin: 0 auto;
    padding-top: 100px;
    max-width: 600px;
  }
  .otp-box > .el-form-item__content {
    display: flex;

    .otp-input {
      margin-right: 5px;
    }
  }
</style>
